import { soilColors, IGenericAnalysis } from "../omnia"
import { IDataLayer, IDataLayerZone } from "../types"
import { getCurrentAnalysisLayer } from "./utils"

export function createFieldAnalysis<TAnalysis extends IGenericAnalysis, TVm extends AnalysisVM<TAnalysis>>(analysis: TAnalysis[], field: { fieldId: number }, factory: (analysis: TAnalysis) => TVm, selectedZoneId: number, setSelected: boolean) {

    let vm = analysis
        .filter(s => s.Allocations.some(a => (a.FieldId === field.fieldId) && (!a.ZoneId) && (!a.ZoneAlloc)))
        .sort((a1, a2) => a2.SamplingDate.valueOf() - a1.SamplingDate.valueOf())
        .map((a, index) => {
            let vm = factory(a);
            vm.current = !index;
            vm.selected = setSelected && (!selectedZoneId) && vm.current;
            return vm;
        });

    return vm;

}

export function createZoneAnalysis<TAnalysis extends IGenericAnalysis, TVm extends AnalysisVM<TAnalysis>>(analysis: TAnalysis[], field: { fieldId: number }, year: number, layers: IDataLayer[], factory: (analysis: TAnalysis, layer: IDataLayer, zone: IDataLayerZone) => TVm, selectedZoneId: number, setSelected: boolean) {

    analysis = analysis
        .filter(s => s.Allocations.some(a => a.FieldId === field.fieldId && ((!!a.ZoneId) || a.ZoneAlloc)));

    let analysisLayer = getCurrentAnalysisLayer(field, year, layers);

    if (!analysisLayer) return [];
    if (!analysisLayer.Zones) return [];

    let vm = analysisLayer.Zones.filter(z => !!z.Value).map(z => {

        let zoneAnalysis = analysis
            .filter(s => s.Allocations.filter(a => a.ZoneId === z.DataLayerZoneId).length > 0)
            .sort((a, b) => a.SamplingDate > b.SamplingDate ? -1 : a.SamplingDate < b.SamplingDate ? 1 : 0);

        return zoneAnalysis.length ? factory(zoneAnalysis[0], analysisLayer, z) : null;

    });

    vm = vm.filter(z => !!z);

    vm = vm.sort((z1, z2) => (z1.zone.Number || 0) - (z2.zone.Number || 0));

    vm.forEach(z => {
        z.current = true;
        z.selected = setSelected && (z.zone.DataLayerZoneId == selectedZoneId);
    });

    return vm;

}

export class AnalysisVM<TAnalysis extends IGenericAnalysis> {



    constructor(public analysis: TAnalysis, public layer?: IDataLayer, public zone?: IDataLayerZone) {
    }

    public selected: boolean;

    public current: boolean;

    get samplingDate(): Date {
        return this.analysis.SamplingDate;
    }

    public isZonal() {
        return !!this.zone;
    }

    getGaugeStyle(key: string, value: number): any {
        return soilColors.getGaugeStyle(value, key);
    }

    getAnalysisIndex(key: string, value: number): any {
        return soilColors.getValueIndex(value, key);
    }


}
